module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_altendorf-6abcaaaa25fb602cf914378ea478bea8.png";